/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import TwoFactorAuthTotpFormBaseComponent from 'cio/components/two-factor-auth/totp-form';

export default class TwoFactorAuthTotpFormPersonalSecuritySettings extends TwoFactorAuthTotpFormBaseComponent {}
